import { CenterBox, LeftBox, SpaceBetweenBox } from "./commons/BoxAbstraction";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YouTubeIcon from "@mui/icons-material/YouTube";
import XIcon from "@mui/icons-material/X";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EmailIcon from "@mui/icons-material/Email";
import {
  Box,
  Button,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useState } from "react";
import MeetingModal from "./MeetingModal";
import useGAEventsTracker from "./GAEventsHook";

const Footer = () => {
  const GAEventsTracker = useGAEventsTracker("Footer Activity");
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [showMeeting, setShowMeeting] = useState(false);

  const footerContent = {
    socialMedia: {
      logo: "niroggyanWhiteLogo.png",
      mediaDetails: [
        {
          icon: (
            <FacebookIcon
              sx={{ 
                color: "#fff", 
                fontSize: isMobile ? "14px" : isSmallScreen ? "18px" : "24px",
                transition: "transform 0.2s ease",
                "&:hover": { transform: "scale(1.1)" }
              }}
            />
          ),
          link: "https://www.facebook.com/niroggyan",
        },
        {
          icon: (
            <InstagramIcon
              sx={{ 
                color: "#fff", 
                fontSize: isMobile ? "14px" : isSmallScreen ? "18px" : "24px",
                transition: "transform 0.2s ease",
                "&:hover": { transform: "scale(1.1)" }
              }}
            />
          ),
          link: "https://www.instagram.com/niroggyan_officialpage/?igsh=MWI4cXdzNjMwOW1ycw%3D%3D#",
        },
        {
          icon: (
            <LinkedInIcon
              sx={{ 
                color: "#fff", 
                fontSize: isMobile ? "14px" : isSmallScreen ? "18px" : "24px",
                transition: "transform 0.2s ease",
                "&:hover": { transform: "scale(1.1)" }
              }}
            />
          ),
          link: "https://www.linkedin.com/company/niroggyan",
        },
        {
          icon: (
            <XIcon
              sx={{ 
                color: "#fff", 
                fontSize: isMobile ? "14px" : isSmallScreen ? "18px" : "24px",
                transition: "transform 0.2s ease",
                "&:hover": { transform: "scale(1.1)" }
              }}
            />
          ),
          link: "https://x.com/niroggyanhealth",
        },
        {
          icon: (
            <YouTubeIcon
              sx={{ 
                color: "#fff", 
                fontSize: isMobile ? "14px" : isSmallScreen ? "18px" : "24px",
                transition: "transform 0.2s ease",
                "&:hover": { transform: "scale(1.1)" }
              }}
            />
          ),
          link: "https://www.youtube.com/channel/UC4CmbjD2IHANS5bf3wQMbmA",
        },
      ],
      text: "Made with ❤️ by the health geeks at NirogGyan",
    },

    bookDemo: {
      image: "footerImage.png",
    },
  };

  return (
    <SpaceBetweenBox
      sx={{
        background: "#022674",
        padding: isMobile ? "12px 8px 12px 12px" : isSmallScreen ? "20px 16px 20px 20px" : "24px 50px",
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          maxWidth: isMobile ? "35%" : isSmallScreen ? "32%" : "30%",
        }}
      >
        <Box
          component="img"
          src={`/images/${footerContent.socialMedia.logo}`}
          alt="niroggyan-logo"
          sx={{
            width: isMobile ? "70px" : isSmallScreen ? "100px" : "60%",
            maxWidth: "180px",
          }}
        />
        <Box>
          <LeftBox
            sx={{
              gap: isMobile ? "8px" : isSmallScreen ? "12px" : "20px",
              marginTop: isMobile ? "12px" : isSmallScreen ? "16px" : "24px",
            }}
          >
            {footerContent.socialMedia.mediaDetails.map((each, index) => (
              <a 
                key={index}
                href={each.link} 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ display: "flex", alignItems: "center" }}
              >
                {each.icon}
              </a>
            ))}
          </LeftBox>
          <Typography
            sx={{ 
              color: "#fff",
              fontFamily: "Poppins, sans-serif",
              fontSize: isMobile ? "10px" : isSmallScreen ? "12px" : "14px",
              fontWeight: 400,
              lineHeight: 1.5,
              mt: isMobile ? 1.5 : 2
            }}
          >
            {footerContent.socialMedia.text}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          maxWidth: isMobile ? "30%" : isSmallScreen ? "28%" : "30%",
          alignSelf: "flex-start",
          paddingTop: isMobile ? "8px" : "10px",
        }}
      >
        <Typography
          sx={{ 
            color: "#fff",
            fontFamily: "Poppins, sans-serif",
            fontSize: isMobile ? "14px" : isSmallScreen ? "18px" : "22px",
            fontWeight: 600,
            mb: isMobile ? 1.5 : isSmallScreen ? 2 : 2.5
          }}
        >
          Contact Us
        </Typography>
        <Box>
          <LeftBox gap={isMobile ? 0.75 : isSmallScreen ? 1 : 1.5}>
            <LocationOnIcon
              sx={{
                color: "#fff",
                fontSize: isMobile ? "14px" : isSmallScreen ? "18px" : "22px",
                alignSelf: "flex-start",
                mt: 0.25,
                flexShrink: 0
              }}
            />
            <Typography
              sx={{ 
                color: "#fff", 
                fontFamily: "Poppins, sans-serif",
                fontSize: isMobile ? "10px" : isSmallScreen ? "12px" : "14px",
                fontWeight: 400,
                lineHeight: 1.5
              }}
            >
              D-533, Sec 1, Avantika Rohini, New Delhi, India - 110085
            </Typography>
          </LeftBox>
          <LeftBox gap={isMobile ? 0.75 : isSmallScreen ? 1 : 1.5} mt={1.5}>
            <EmailIcon
              sx={{ 
                color: "#fff", 
                fontSize: isMobile ? "14px" : isSmallScreen ? "18px" : "22px",
                flexShrink: 0
              }}
            />
            <a 
              href="mailto:sales@niroggyan.com" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              <Typography
                sx={{
                  color: "#fff",
                  fontFamily: "Poppins, sans-serif",
                  fontSize: isMobile ? "10px" : isSmallScreen ? "12px" : "14px",
                  fontWeight: 400,
                  lineHeight: 1.5,
                  "&:hover": {
                    textDecoration: "underline",
                  },
                }}
              >
                sales@niroggyan.com
              </Typography>
            </a>
          </LeftBox>
        </Box>
      </Box>

      <Box sx={{ position: "relative" }}>
        <Box>
          <Box
            component="img"
            src={`/images/${footerContent.bookDemo.image}`}
            alt="footer-logo"
            sx={{ width: isSmallScreen ? "105px" : "100%" }}
          />
        </Box>

        <Button
          variant={isSmallScreen ? "mobile" : "contained"}
          sx={{
            background: "#DAE5FF",
            color: "#3567D6",
            padding: isSmallScreen ? "4px 8px" : "6px 10px",
            border: isSmallScreen ? "2px solid #3CD0FF" : "3px solid #3CD0FF",
            "&:hover": { color: "#fff" },
            position: "absolute",
            top: isSmallScreen ? "8px" : "28px",
            left: isSmallScreen ? "-34px" : "-90px",
          }}
          onClick={() => {
            GAEventsTracker("Demo Booked");
            setShowMeeting(true);
          }}
        >
          Book Demo
        </Button>
      </Box>

      <MeetingModal showMeeting={showMeeting} setShowMeeting={setShowMeeting} />
    </SpaceBetweenBox>
  );
};

export default Footer;
